import ajax from '../../../components/ajax';
export default function useSimilarApi(productId) {
    function request(data) {
        data.product_id = productId;
        return ajax('/api/similar', data, { dataType: "json", })
            .then(response => response.json());
    }
    return {
        add: (similar_id) => request({ action: 'add', similar_id }),
        delete: (similar_id) => request({ action: 'delete', similar_id }),
        getActive: () => request({ action: 'get_active' }),
        search: (query) => request({ action: 'search', query }),
        vote: (vote, similar_id) => request({ action: 'vote', similar_id, vote }),
    };
}
